import { Component } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';

@Component({
  selector: 'app-visa-and-work-eligibility',
  standalone: true,
  imports: [AccordionModule],
  templateUrl: './visa-and-work-eligibility.component.html',
  styleUrl: './visa-and-work-eligibility.component.scss'
})
export class VisaAndWorkEligibilityComponent {

}
